<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Title tag="h1">Publicaciones</Title>
      <div class="space-between">
        <ButtonsGroup>
          <span class="db-md">
            Consultar:
          </span>
          <Button
            :class="`${paramYear == '' && 'active'}`"
            tag="router-link"
            to="/publicaciones"
            theme="primary"
          >
            Todas
          </Button>
          <template v-for="(year, index) in buttonYears" :key="index">
            <Button
              tag="router-link"
              :to="`/publicaciones/${year}/`"
              :class="`${paramYear == year && 'active'}`"
              theme="primary"
            >
              {{ year }}
            </Button>
          </template>
        </ButtonsGroup>
        <ButtonsGroup>
          <FormField
            autofocus
            tag="input"
            name="select_date"
            type="text"
            placeholder="1972"
            min="1800"
            size="small"
            :max="currentYear"
            :options="options"
            @getValue="changeDate"
            @keyup.enter="getPublicationsByDate"
          />
          <Button theme="primary" @click="getPublicationsByDate" type="submit">
            <Search />
          </Button>
        </ButtonsGroup>
      </div>
      <Title tag="h2">{{ title }}</Title>
      <Suspense>
        <template #default>
          <PublicationList :url="url" />
        </template>
        <template #fallback>
          <Loader />
        </template>
      </Suspense>
    </Container>
  </main>
</template>

<script>
import Container from "@/components/ui/objects/Container";
import Trail from "@/components/common/Trail";
import Title from "@/components/ui/atoms/Title";
import Button from "@/components/ui/atoms/Button";
import Search from "@/components/icons/Search";
import Loader from "@/components/common/Loader";
import FormField from "@/components/ui/atoms/FormField";
import ButtonsGroup from "@/components/ui/form/ButtonsGroup";
import { useRoute, useRouter } from "vue-router";
import { defineAsyncComponent } from "vue";

export default {
  components: {
    Loader,
    Container,
    Trail,
    Title,
    Button,
    Search,
    ButtonsGroup,
    FormField,
    PublicationList: defineAsyncComponent(() =>
      import("../components/publications/PublicationList")
    )
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const paramRoute = route.fullPath;
    const paramYear = route.params.year;
    const currentYear = new Date().getFullYear();
    const range = (start, stop, step) =>
      Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
      );
    const buttonYears = range(currentYear, currentYear - 4, -1);

    const url = process.env.VUE_APP_REGEN_API;
    let year = route.params.year || 2020;
    const page = route.params.page || 1;
    const title = route.params.year
      ? `Publicaciones del año ${year}`
      : "Todas las publicaciones";

    const options = [
      { text: "Otro Año", value: -1 },
      { text: 2016, value: 2016 },
      { text: 2015, value: 2015 },
      { text: 2014, value: 2014 },
      { text: 2013, value: 2013 },
      { text: 2012, value: 2012 }
    ];

    const changeDate = newYear => {
      year = newYear;
    };

    const getPublicationsByDate = () => {
      router.push({
        name: "Publicaciones",
        params: { year: year },
        query: { ...route.query, page: 1 }
      });
    };

    return {
      paramRoute,
      paramYear,
      buttonYears,
      url,
      currentYear,
      year,
      page,
      title,
      options,
      changeDate,
      getPublicationsByDate
    };
  }
};
</script>
<style lang="scss" scoped>
.space-between {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
@media screen and (min-width: 768px) {
  .space-between {
    flex-direction: row;
  }
}
</style>
